import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function CustomSelect({
  filterValue,
  setFilterValue,
  title,
  options
}) {
  const handleChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <FormControl
      fullWidth
      size="medium"
      variant="outlined"
      sx={{
        minWidth: 130,
        maxWidth: 220,
        overflow: 'visible',
        /* room for floating label above the notch */
        mt: 0.5,
        '& .MuiInputLabel-root': {
          overflow: 'visible'
        }
      }}
    >
      <InputLabel id="demo-select-small-label">{title}</InputLabel>
      <Select
        labelId="demo-select-small-label"
        id="demo-select-small"
        className='list_filter_select'
        value={filterValue}
        label={title}
        onChange={handleChange}
      >
        {options?.map((menu, index) => (
          <MenuItem className='list_filter_select_menu' key={`${index}-${menu.label}`} value={menu.value}>
            {menu.key || menu.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
